import PropTypes from 'prop-types';
import get from 'lodash/get';
import { capitalize } from "lodash";

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
// import CircleIcon from '@mui/icons-material/Circle';
import Typography from '@mui/material/Typography';

import ClaimFilters from './ClaimFilters';
import ClaimsTable from './ClaimsTable';
import LoadingScreen from '../common/LoadingScreen';

const TableView = props => {
  if (props.isLoading) return <LoadingScreen />;
  return (
    <Box>
      <ClaimsTable
        {...props}
        rows={(props.claims || []).map(c => ({ data: c }))}
      />
    </Box>
  );
};

const ListClaimsScreen = props => {
  return (
    <Box className="list-session" marginTop='12px'>
      <ClaimFilters
        filters={props.filters}
        onFilterChange={props.onFilterChange}
      />
      <Card className="list-session__card drop-shadow">
        <CardContent>
          <Box>
            <Box sx={{ display: {xs: 'none', md: 'block'}, marginLeft: '0.365rem'}}>
              {props.isUpdating && 
                <Stack direction='row' spacing={1} justifyContent='flex-end' alignItems='center'>
                  <CircularProgress size={20} />
                  <Typography variant='body2' color='text.gray'>Refreshing</Typography>
                </Stack>
              }
            </Box>
          </Box>
          {<TableView
              isLoading={props.isLoading}
              isUpdating={props.isUpdating}
              claims={props?.claims || []}
              pageSize={props.pageSize}
              pageIndex={props?.pageIndex || 0}
              count={props?.count || 0}
              onPageChange={props.onPageChange}
              afterSave={props.refetch || null}
            />
          }
        </CardContent>
      </Card>
    </Box>
  );
};

ListClaimsScreen.propTypes = {
  filters: PropTypes.object,
  tab: PropTypes.string,
  counts: PropTypes.object,
};

export default ListClaimsScreen;
